import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

const MISSING = !supabaseUrl || !supabaseKey;

if (MISSING) {
  // eslint-disable-next-line no-console
  console.warn(
    '[Trelledex] Supabase env vars not set. ' +
    'Add REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY to your Vercel project settings.'
  );
}

// Provide safe fallback so the app loads even without credentials — data fetches will return empty.
export const supabase = MISSING
  ? null
  : createClient(supabaseUrl, supabaseKey);
